const strings: any = {
  main: {
    contactUs: "להצטרפות ופרטים נוספים מנציג השאירו פרטים",
    payOnline: "רכישה אונליין",
    leftMessage: "השארת הודעה",
    whatIncludes: "?מה תקבלו",
    rightsReserved: "כל הזכויות שמורות ל-goola",
  },
};
export default strings;
